module.exports = __webpack_public_path__ + "img/linkedin_extension.2b6ef57f.gif";